import { useFeatureFlag } from '@glossgenius/core-features-react-sdk';

import { FEATURE_FLAGS } from 'core-features-config/activeFeatureFlags';

export const useSmartServiceOrderingFeatureFlag = () => {
  const { isEnabled, isLoading } = useFeatureFlag(
    FEATURE_FLAGS.SMART_SERVICE_ORDERING,
  );

  return { isEnabled, isLoading };
};
